// Configuração de build do painel (cozida pelo CRA via REACT_APP_*).

// Link de download do app Nano usado no template de compartilhamento (plano §7.3).
// Configurável por REACT_APP_APP_LINK; fallback é um placeholder que o dono
// deve ajustar para a URL real de download antes de divulgar.
export const APP_DOWNLOAD_LINK =
    process.env.REACT_APP_APP_LINK?.trim() || "https://nanoplay.app"
